module.exports = __webpack_public_path__ + "img/1700-2_YR_2022_Malware.f67fc6fc.png";